import { useTranslation } from "react-i18next";
import CountdownBanner from "@/components/CountdownBanner";

// Open beta release target — 12:00 UTC on 1 Jan 2027
const TARGET = new Date(Date.UTC(2027, 0, 1, 12, 0, 0));

export default function BetaCountdown() {
  const { t } = useTranslation();
  return (
    <CountdownBanner
      target={TARGET}
      direction="down"
      accent="cyan"
      testId="beta-countdown"
      eyebrow={t("home.betaEyebrow")}
      dateLabel={t("home.betaDate")}
      liveLabel={t("home.betaLive")}
      labels={{
        days:    t("home.countdownDays"),
        hours:   t("home.countdownHrs"),
        minutes: t("home.countdownMin"),
        seconds: t("home.countdownSec"),
      }}
    />
  );
}
